import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

export default function DealRequestCard(props) {
  const [dealData, setDealData] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  const moveToDealDetailsPage = e => {
    localStorage.setItem("dealData", JSON.stringify({}));
    localStorage.setItem("dealData", JSON.stringify(e));
  };
  const makeTitle = string => string.charAt(0).toUpperCase() + string.slice(1);

  // Function to get display status based on mapping
  const getDisplayStatus = status => {
    const pendingStatuses = ["new", "prospect", "not_interested"];
    const inProgressStatuses = ["active", "inprogress", "assigned", "escalate", "pending", "payment_pending"];
    const normalizedStatus = status?.toLowerCase().replace(/\s+/g, "_");

    if (pendingStatuses.includes(normalizedStatus)) {
      return "Pending";
    }
    if (inProgressStatuses.includes(normalizedStatus)) {
      return "In-Progress";
    }
    return status;
  };

  useEffect(() => {
    setIsMobile(window.innerWidth <= 768);
    setDealData(pre => {
      let newData = props.data;
      switch (newData.status) {
        case "assigned":
          newData.color = "#22A50D";
          break;
        case "demo":
          newData.color = "#FF9900";
          break;
        case "pending":
          newData.color = !newData.advance_payment ? "#FF0000" : "#7ba8e4";
          break;
        default:
      }
      return newData;
    });
  }, []);

  const displayStatus = getDisplayStatus(dealData.status);

  const formatDate = dateString => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  return (
    dealData.id && (
      <NavLink
        to="/deal-details"
        onClick={() => {
          moveToDealDetailsPage(dealData);
        }}>
        <div className="scroll-vertical-container">
          <div
            className={`request-card status-${dealData.status?.toLowerCase().replace(/\s+/g, "_")}`}
            style={{ position: "relative" }}>
            <div style={{ position: "absolute", top: "10px", right: "15px", textAlign: "right" }}>
              <span className={`status status--${displayStatus?.toLowerCase()}`}>
                {displayStatus?.charAt(0)?.toUpperCase() + displayStatus?.slice(1)?.toLowerCase()}
              </span>
              <span className={` status-badge status-badge--${displayStatus?.toLowerCase()}`} style={{ padding: '4px' }}></span>
            </div>
            <div className="tutor-scroll-body mt-2 d-flex-col gap-2">
              <div className="tutor-scroll-header-rht-txt" style={{ paddingRight: "100px" }}>
                <strong>Subjects :</strong> {dealData.student_requirments}
              </div>
              <div className="tutor-scroll-header-rht-txt d-flex align-center justify-start gap-2">
                <strong>Classes/Week :</strong> {dealData?.how_many_days_in_a_week}
              </div>
              <div className="tutor-scroll-header-rht-txt d-flex align-center justify-start gap-2">
                <strong>Level/Course:</strong> {dealData.study_level} / {dealData.name}
              </div>

              {dealData.fee_discuss != null && (
                <div className="tutor-scroll-header-rht-txt d-flex align-center justify-start gap-2">
                  <strong>Fees:</strong> {dealData.fee_discuss}
                </div>
              )}
              <div className="req-date">Req Date: {formatDate(dealData.created_at)}</div>
            </div>
          </div>
        </div>
        {/* <div className='request-deals--wrapper' style={{borderLeftColor:dealData.color}} >
            <div className='deal-request-card--top-part'>
                <div className='deal-request-card--top-part--left'>
                    <img src={`/${dealData.status}-card-icon.svg`} alt="Bell Notification" width={`${(!isMobile)?"35":"25"}`} height={`${(!isMobile)?"35":"25"}`} />
                    <div style={{color:'#bebcbc'}}>{dealData.tution_type}</div>
                </div>
                <div className='deal-request-card--top-part--right'>
                    <div className='deal-request-card--light' style={{backgroundColor:dealData.color,boxShadow:`0px 0px 5px ${dealData.color}`}}></div>
                    <div className='deal-request-card--status' style={{color:dealData.color,fontWeight:"600"}}>{makeTitle((dealData.advance_payment&&dealData.status==="pending")?"In Progress":dealData.status)}</div>
                </div>
            </div>
            <div className='deal-request-card--mid-part'>
                {dealData.created_at}
            </div>
            <div className='deal-request-card--bottom-part'>
                <div><span style={{color:"rgba(130, 130, 130, 1)",fontSize:"16px",fontWeight:"500"}}>Subjects : </span>{(isMobile)?dealData.student_requirments.substring(0,25):dealData.student_requirments.substring(0,50)}{((dealData.student_requirments.length>25&&isMobile)||(dealData.student_requirments.length>50&&!isMobile))&&'...'} </div>
                <div style={{textDecoration:"underline"}}>View</div>
            </div>
        </div> */}
      </NavLink>
    )
  );
}
